import React from "react";
import { Alert, Tag, Tooltip } from "antd";
import { ApiKeyCheck } from "reducers/types";

// The provider answered and refused the key (as opposed to: not reached, still checking)
const rejected = (check: ApiKeyCheck | null) => !!check && check.loaded && !check.valid && !!check.httpStatus;

/** Tags for a job card title: is the provider's API key loaded on the server, and did the provider accept it. */
export const apiKeyTags = (keyLoaded: boolean | undefined, check: ApiKeyCheck | null) => (
  <>
    {keyLoaded === undefined ? null : keyLoaded ? (
      <Tag color="green">API key loaded</Tag>
    ) : (
      <Tag color="red">API key missing</Tag>
    )}
    {!check || !check.loaded ? null : check.valid ? (
      <Tag color="green">API key accepted</Tag>
    ) : (
      <Tooltip title={check.message || undefined}>
        {check.httpStatus ? (
          <Tag color="red">API key rejected (HTTP {check.httpStatus})</Tag>
        ) : (
          <Tag color="orange">API key not checked</Tag>
        )}
      </Tooltip>
    )}
  </>
);

/** A notice to show instead of the start form when jobs cannot be started; null when they can. */
export const apiKeyNotice = (
  envName: string,
  providerName: string,
  keyLoaded: boolean | undefined,
  check: ApiKeyCheck | null,
) => {
  if (keyLoaded === false) {
    return <Alert type="warning" showIcon message={`${envName} is not loaded on the server — jobs cannot be started`} />;
  }
  if (rejected(check)) {
    return (
      <Alert
        type="warning"
        showIcon
        message={`${providerName} rejected the API key — jobs cannot be started`}
        description={check && check.message ? check.message : undefined}
      />
    );
  }
  return null;
};
